import { defineChain } from '@reown/appkit/networks'
import { AppKitNetwork } from '@reown/appkit/networks'

export const bscChain: AppKitNetwork = /*#__PURE__*/ defineChain({
  id: 56,
  name: 'BNB Smart Chain',
  nativeCurrency: {
    decimals: 18,
    name: 'BNB',
    symbol: 'BNB',
  },
  rpcUrls: {
    default: { http: ['https://bsc-rpc.mtt.network'] },
  },
  blockExplorers: {
    default: {
      name: 'BscScan',
      url: 'https://bscscan.com',
      apiUrl: 'https://api.bscscan.com/api',
    },
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 15921452,
    },
  },
  chainNamespace: 'eip155',
  caipNetworkId: 'eip155:56',
}) as AppKitNetwork
